import fetch from 'isomorphic-unfetch';
import { getConfig } from '@belong/configs/next/config';
import { Entry } from 'contentful';

import { logger } from '@belong/logging/logger';
import { ENVS } from '@belong/types';
import { print, DocumentNode } from 'graphql';

import { getArticlesByCategoryQuery } from './queries/getArticlesByCategory.gql';

const { environment, space, accessToken } = getConfig().publicRuntimeConfig.contentful;
const API_ROOT = 'https://graphql.contentful.com/content/v1/spaces';
const BEARER_TOKEN = `Bearer ${accessToken}`;

const debugGQLError = (query: string, variables: any, error: any): void => {
  if (getConfig().publicRuntimeConfig.env.isTest) {
    return;
  }

  logger.error('Query:', query);
  logger.error('Variables:', variables);
  logger.error('Error:', error);
};

export class ContentGQL {
  private endpoint = `${API_ROOT}/${space}/environments/${environment}`;

  async execQuery(query: string | DocumentNode, vars?: any): Promise<any> {
    const { publicRuntimeConfig } = getConfig();

    const theQuery = typeof query === 'string' ? query : print(query);

    const variables = { ...vars, isPreview: publicRuntimeConfig.env.stage === ENVS.PREVIEW };
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify({ query: theQuery, variables }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: BEARER_TOKEN
      }
    };

    try {
      const result: any = await fetch(this.endpoint, requestOptions);
      const data: any = await result.json();
      if (data.errors) {
        debugGQLError(theQuery, variables, data);
        return {};
      }
      return data;
    } catch (err) {
      debugGQLError(theQuery, variables, err.message);
      return {};
    }
  }

  async getArticlesByCategory(categories: string[], limit = 1000): Promise<Entry<any>[]> {
    const result = await this.execQuery(getArticlesByCategoryQuery, { categories, limit });
    return result.data?.supportArticleCollection.items || [];
  }
}

export default new ContentGQL();
